module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customerComment":"Client\u0027s comment","noComment":"No comment."},"et":{"customerComment":"Client\u0027s comment","noComment":"No comment."},"ru":{"customerComment":"Client\u0027s comment","noComment":"No comment."}}')
  delete Component.options._Ctor
}
